import { FC, useEffect } from "react";
import useStyles from "../../../lead/quote/leadEstimateStyle";
import ManageInventoryForm from "./ManageInventoryForm";
import { useDispatch } from "react-redux";
import { getInventoryCrewDetailsAction } from "../../../../../store/reducers/inventoryCrewSlice";

interface ManageInventoryBingoProps {
  show: boolean;
  setShow: (show: boolean) => void;
  selectedCrewRow?: any;
  readOnly?: boolean;
}

const ManageInventoryBingo: FC<ManageInventoryBingoProps> = ({
  show,
  setShow,
  selectedCrewRow,
  readOnly = false,
}) => {
  const classes = useStyles({ show });
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCrewRow && show) {
      dispatch(
        getInventoryCrewDetailsAction({
          contractId: selectedCrewRow?.contract_id,
          role: "client",
        }),
      );
    }
  }, [dispatch, selectedCrewRow, show]);
  console.log("selectedCrewRow", selectedCrewRow);
  return (
    <>
      {show && (
        <section className={show ? classes.estimatePopupOverlay : ""}>
          <ManageInventoryForm
            show={show}
            setShow={setShow}
            screenType={"Storage Contract"}
            readOnly={readOnly}
          />
        </section>
      )}
    </>
  );
};

export default ManageInventoryBingo;
